import { AppBar, Box, Button, Checkbox, Chip, Container, Divider, FormGroup, Grid2, InputAdornment, styled, SvgIcon, Switch, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import MenuHeader from './MenuHeader';
import useApi from '../hooks/useApi';
import UserService from '../services/user.service';
import SearchIcon from '@mui/icons-material/Search';
import KeyIcon from '@mui/icons-material/Key';
import HomeIcon from '@mui/icons-material/Home';
import TodayIcon from '@mui/icons-material/Today';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CategoryIcon from '@mui/icons-material/Category';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BedroomParentIcon from '@mui/icons-material/BedroomParent';
import Face5Icon from '@mui/icons-material/Face5';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import TableChartIcon from '@mui/icons-material/TableChart';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import MapIcon from '@mui/icons-material/Map';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import { ReactComponent as IncognitoIcon } from '../assets/icons/incognito.svg';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { asTitle } from '../shared/utils/string';
import RbacService from '../services/rbac.service';
import { ro, tr } from 'date-fns/locale';
import { set } from 'date-fns';
import { useNotifications } from '../context/NotificationProvider';

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '&:hover': {
    transform: 'scale(1.05)',
  },
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '50%',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 12H6V10h12z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: 'red',
    width: 32,
    height: 32,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '50%',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"/></svg>')`,
    },
  },
  '& .Mui-checked .MuiSwitch-thumb': {
    backgroundColor: 'green',
    width: 32,
    height: 32,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: '#aab4be',
    borderRadius: 20 / 2,
    ...theme.applyStyles('dark', {
      backgroundColor: '#8796A5',
    }),
  },
}));

export const RoleBasedAccessControl = () => {
  const api = useApi();
  const [permissions, setPermissions] = useState([]);
  const [models, setModels] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [modelColumns, setModelColumns] = useState([]);
  const [filteredModelColumns, setFilteredModelColumns] = useState([]);
  const [colors, setColors] = useState([]);
  const [roleColors, setRoleColors] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedRolePermissions, setSelectedRolePermissions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedPermissionsTab, setSelectedPermissionsTab] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editedPermissions, setEditedPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [addRole, setAddRole] = useState(false);
  const [newRoleName, setNewRoleName] = useState('');
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const notify = useNotifications();

  const MODEL_MUI_ICONS_AND_COLORS = {
    'users': { icon: (props) => <KeyIcon {...props} /> },
    'addresses': { icon: (props) => <HomeIcon {...props} /> },
    'calendars': { icon: (props) => <TodayIcon {...props} /> },
    'calendars_managements': { icon: (props) => <TodayIcon {...props} /> },
    'calendars_managements_slots': { icon: (props) => <TodayIcon {...props} /> },
    'cards': { icon: (props) => <CreditCardIcon {...props} /> },
    'card_brands': { icon: (props) => <CreditCardIcon {...props} /> },
    'categories': { icon: (props) => <CategoryIcon {...props} /> },
    'domains': { icon: (props) => <ViewInArIcon {...props} /> },
    'fiche_clients': { icon: (props) => <DocumentScannerIcon {...props} /> },
    'zones': { icon: (props) => <MapIcon {...props} /> },
    'bookings': { icon: (props) => <ShoppingCartIcon {...props} /> },
    'booking_products': { icon: (props) => <ShoppingCartCheckoutIcon {...props} /> },
    'gift_configurations': { icon: (props) => <CardGiftcardIcon {...props} /> },
    'media': { icon: (props) => <PermMediaIcon {...props} /> },
  };
  const PROTECTED_ROLES = ['ROLE_HOTEL_MANAGER', 'ROLE_CLIENT', 'ROLE_PAYMENT_PROCESSOR', 'ROLE_GUEST', 'ROLE_MANAGER', 'ROLE_FLYPRO', 'ROLE_ADMIN'];

  const ROLE_TABS = {
    'ROLE_ADMIN': { label: 'Administrator', description: 'Manage administrator permissions', icon: (props) => <AdminPanelSettingsIcon {...props} /> },
    'ROLE_MANAGER': { label: 'Manager', description: 'Manage manager permissions', icon: (props) => <ManageAccountsIcon {...props} /> },
    'ROLE_HOTEL_MANAGER': { label: 'Hotel Manager', description: 'Manage hotel manager permissions', icon: (props) => <BedroomParentIcon {...props} /> },
    'ROLE_CLIENT': { label: 'Client', description: 'Manage client permissions', icon: (props) => <Face5Icon {...props} /> },
    'ROLE_FLYPRO': { label: 'flypro', description: 'Manage flypro permissions', icon: (props) => <PersonPinCircleIcon {...props} /> },
    'ROLE_PAYMENT_PROCESSOR': { label: 'Payment Processor (Wallee)', description: 'Manage payment processor permissions', icon: (props) => <AccountBalanceIcon {...props} /> },
    'ROLE_GUEST': { label: 'Guest', description: 'Manage guest permissions', icon: (props) => <SvgIcon component={IncognitoIcon} {...props} /> },
  };

  const MODEL_ACTIONS = {
    'manage': {
      label: 'Manage', description: 'Can manage model', icon: <SettingsApplicationsOutlinedIcon sx={{ color: 'fuscia' }} />, children: {
        'manage.permissions': { label: 'Manage Permissions', description: 'Can manage permissions of model' },
      },
    },
    'read': {
      label: 'View', description: 'Can view records', icon: <VisibilityIcon color='primary' />, children: {
        'read.all': { label: 'Read All', description: 'Can read all records from model' },
        'read.self': { label: 'Shared or Owned', description: 'Can read records that belongs to the user from model' },
      },
    },
    'create': {
      label: 'Create', description: 'Can create new records', icon: <AddIcon color='success' />
    },
    'edit': {
      label: 'Update', description: 'Can modify existing records', icon: <EditNoteIcon color='warning' />, children: {
        'edit.all': { label: 'Update All', description: 'Can update all records from model' },
        'edit.self': { label: 'Update Shared or Owned', description: 'Can update records that belongs to the user from model' },
      },
    },
    'destroy': {
      label: 'Delete', description: 'Can delete records', icon: <DeleteOutlineIcon color='error' />, children: {
        'destroy.all': { label: 'Delete All', description: 'Can delete all records from model' },
        'destroy.self': { label: 'Delete Shared or Owned', description: 'Can delete records that belongs to the user from model' },
        'destroy.soft': { label: 'Trash', description: 'Can soft delete records from model' },
        'destroy.force': { label: 'Delete Permanently', description: 'Can permanently delete records from model' },
      },
    },
    'export': {
      label: 'Export', description: 'Can export records', icon: <SystemUpdateAltIcon color='secondary' />,
    },
    'import': {
      label: 'Import', description: 'Can import records', icon: <CloudUploadIcon sx={{ color: 'cyan' }} />,
    },
  };

  const COLUMN_ACTIONS = {
    'manage': {
      label: 'Manage', description: 'Can manage column', icon: <SettingsApplicationsOutlinedIcon sx={{ color: 'fuscia' }} />, children: {
        'manage.permissions': { label: 'Manage Permissions', description: 'Can manage permissions of model' },
      },
    },
    'read': {
      label: 'View', description: 'Can view column', icon: <VisibilityIcon color='primary' />
    },
    'create': {
      label: 'Create', description: 'Can create column for new records', icon: <AddIcon color='success' />
    },
    'edit': {
      label: 'Update', description: 'Can update column for existing records', icon: <EditNoteIcon color='warning' />
    },
    'export': {
      label: 'Export', description: 'Can export column', icon: <SystemUpdateAltIcon color='secondary' />
    },
    'import': {
      label: 'Import', description: 'Can import column', icon: <CloudUploadIcon sx={{ color: 'cyan' }} />
    },
  };

  const fetchCurrentUserPermissions = async () => {
    const response = await UserService.currentUser({ with: 'permissions' }, api);
    setCurrentUserRole(response.user.roles[0].id);
    const userPermissions = response.user?.permissions ?? [];
    const models = userPermissions.filter(permission => permission.split('-').length === 2 && permission.includes('manage.permissions') && !permission.includes('manage.permissions.')).map(permission => permission.split('-')[0]);

    const modelColumns = userPermissions.reduce((acc, permission) => {
      const parts = permission.split('-');
      if (parts.length > 2 && permission.includes('manage.permissions') && !permission.includes('manage.permissions.')) {
        const [model, column] = parts;
        if (!acc[model]) {
          acc[model] = [];
        }
        const match = column.match(/column\[(.+?)\]/);

        if (match) {
          const columnName = match[1];
          acc[model].push(columnName);
        } else {
          acc[model].push(column);
        }
      }
      return acc;
    }, {});
    setModelColumns(modelColumns);
    setPermissions(userPermissions);
    setModels(models);
    setFilteredModels(models);
    setColors(randomHexColors(models.length));
  }

  const handleRoleTabChange = (event, newValue) => {
    setSelectedRole(newValue);
  }

  const handleColumnChange = ($event) => {
    setSelectedColumn($event.currentTarget.dataset.column);
  }

  const handleColumnBack = () => {
    setSelectedColumn(null);
    setFilteredModelColumns(modelColumns[selectedModel]);
  }

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    const filtered = models.filter(model => asTitle(model).toLowerCase().includes(query));
    setFilteredModels(filtered);
  }

  const handleColumnSearch = (event) => {
    const query = event.target.value.toLowerCase();
    const filtered = modelColumns[selectedModel].filter(column => asTitle(column).toLowerCase().includes(query));
    setFilteredModelColumns(filtered);
  }

  const fetchPermissionsOfRole = async (role) => {
    const response = await RbacService.fetchPermissionsOfRole(role, api);
    if (editMode) {
      setEditedPermissions(response);
    }
    setSelectedRolePermissions(response);
    return response;
  }

  useEffect(() => {
    fetchCurrentUserPermissions();
  }, []);

  useEffect(() => {
    if (selectedRole === null || !roles.length) return;
    fetchPermissionsOfRole(roles[selectedRole]?.id);
  }, [selectedRole, roles]);

  useEffect(() => {
    if (roles.length > 0) return; {
      fetchRoles();
    }
  }, [selectedModel]);

  const randomHexColor = () => {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }

  const randomHexColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(randomHexColor());
    }
    return colors;
  }

  const fetchRoles = async () => {
    const response = await RbacService.getRoles(api);
    console.log({ response })
    setRoleColors(randomHexColors(response.length));
    setRoles(response.filter(role => role.id !== currentUserRole));
    setFilteredRoles(response.filter(role => role.id !== currentUserRole));
  }

  const handleSelectModel = ($event) => {
    setSelectedModel($event.currentTarget.dataset.model);
    setSelectedPermissionsTab(0);
    setFilteredModelColumns(modelColumns[$event.currentTarget.dataset.model]);
  }

  const handleBack = () => {
    setSelectedModel(null);
    setSelectedPermissionsTab(null);
  }

  const handlePermissionChange = ($event) => {
    const permission = $event.currentTarget.dataset.permission;
    const currentState = editedPermissions.includes(permission);
    let permissions = [];
    if (currentState) {
      const parentPermission = permission.split('.')[0];
      permissions = editedPermissions.filter(p => !p.startsWith(permission) && (!p.includes(`${parentPermission}.all`)));
    } else {
      permissions = [...editedPermissions, permission];
    }
    setEditedPermissions(permissions);
  }

  const togglePermissionsEditState = () => {
    if (!editMode) {
      setEditedPermissions(selectedRolePermissions);
    } else {
      setEditedPermissions([]);
    }
    setEditMode(!editMode);
  }

  const isPermissionChecked = (permission) => {
    const permissions = editMode ? editedPermissions : selectedRolePermissions;
    if (permission.includes('column[')) {
      const action = permission.split('-')[2];
      if (!permissions.includes(`${permission.split('-')[0]}-${action}`)) {
        return false;
      }
    }
    return permissions.includes(permission);
  }

  const handleAddRole = () => {
    setAddRole(true);
    setNewRoleName('');
    setTimeout(() => {
      const input = document.querySelector('input[name="newRoleName"]');
      input?.focus();
      input?.select();
      input?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  const cancelAddRole = () => {
    setAddRole(false);
    setNewRoleName('');
    document.querySelector('.menu-header').scrollIntoView({ behavior: 'smooth' });
  }

  const handleAddRoleSubmit = async () => {
    try {
      if (!newRoleName) {
        notify.warn('Role Name is required');
        return;
      }
      const response = await RbacService.storeRole(`ROLE_${newRoleName}`, api);
      setRoles([...roles, response.data]);
      setFilteredRoles([...roles, response.data]);
      document.querySelector('.menu-header').scrollIntoView({ behavior: 'smooth' });
      document.querySelector('input[name="rolesSearch"]')?.setAttribute('value', newRoleName);
      setAddRole(false);
      setNewRoleName('');
    } catch (error) {

    }
  }

  const handleSavePermissions = async () => {
    try {
      // instead of editedPermissions which is huge data only send revoked_permissions and added_permissions
      const revokedPermissions = selectedRolePermissions.filter(permission => !editedPermissions.includes(permission));
      const addedPermissions = editedPermissions.filter(permission => !selectedRolePermissions.includes(permission));
      const response = await RbacService.syncRolePermissions({ role: roles[selectedRole]?.id, revoked_permissions: revokedPermissions, added_permissions: addedPermissions }, api);
      fetchPermissionsOfRole(roles[selectedRole]?.id);
      setEditMode(false);
    } catch (error) {

    }
  }

  const handleRolesSearch = (event) => {
    const query = event.target.value.toLowerCase();
    const filtered = roles.filter(role => asTitle(role.name.replace('ROLE_', '')).toLowerCase().includes(query));
    setFilteredRoles(filtered);
  }

  const handleDeleteRole = async (roleId, roleName) => {
    if (PROTECTED_ROLES.includes(roleName)) {
      notify.error('Cannot delete protected system roles');
      return;
    }
    if (!window.confirm(`Are you sure you want to delete the role "${asTitle(roleName.replace('ROLE_', ''))}"?`)) {
      return;
    }
    try {
      await RbacService.destroyRole(roleId, api);
      fetchRoles();
      notify.success(`Role deleted successfully`);
      if (selectedRole !== null && roles[selectedRole]?.id === roleId) {
        setSelectedRole(null);
      }
    } catch (error) {
      notify.error('Failed to delete role');
    }
  }

  const isRoleProtected = (roleName) => {
    return PROTECTED_ROLES.includes(roleName);
  }

  return (
    <>
      <MenuHeader />
      {selectedRole === null && (
        <Container sx={{ mt: 4, mb: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: 20 }}>
              Roles
            </Typography>
            <TextField
              label="Search"
              variant="outlined"
              onChange={handleRolesSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ '& .MuiInputBase-input': { height: '0.5rem' } }}
            />
          </Box>
          <Divider />
          {/* <Grid2 container spacing={2} columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
            {filteredRoles.map((role, index) => (
              <Grid2 size={1} key={index}>
                <Button sx={{ justifyContent: 'flex-start', width: '100%', color: 'black', textTransform: 'none', padding: '0.5rem', '&:hover': { background: 'rgba(0, 0, 0, 0.1)', transform: 'scale(1.02)' } }} onClick={() => setSelectedRole(index)} data-role={role.name} startIcon={ROLE_TABS[role.name]?.icon || <ManageAccountsIcon />}>
                  <Box>
                    <Typography sx={{ textAlign: 'left', color: 'black' }}>
                      {ROLE_TABS[role.name]?.label || asTitle(role.name.replace('ROLE_', ''))}
                    </Typography>
                    <Typography sx={{ fontSize: 12, textAlign: 'left', color: 'gray' }}>
                      {ROLE_TABS[role.name]?.description || `Manage ${ROLE_TABS[role.name]?.label || asTitle(role.name.replace('ROLE_', ''))} Permissions`}
                    </Typography>
                  </Box>
                </Button>

              </Grid2>
            ))}
            {!addRole && (
              <Button onClick={handleAddRole}>Add Role</Button>
            )}
            {addRole && (
              <Box sx={{ display: 'flex', gap: 1, padding: '1rem' }}>
                <TextField
                  label="Role Name"
                  variant="outlined"
                  name='newRoleName'
                  value={newRoleName}
                  required
                  onChange={(event) => setNewRoleName(event.target.value)}
                />
                <Button onClick={cancelAddRole}>Cancel</Button>
                <Button onClick={handleAddRoleSubmit}>Add</Button>
              </Box>
            )}
          </Grid2> */}
          <Grid2 container spacing={2} columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
            {filteredRoles.map((role, index) => (
              <Grid2 size={1} key={index}>
                <Box className="rbac-card" data-role={role.name} onClick={() => setSelectedRole(index)} sx={{ position: 'relative' }}>
                  {!isRoleProtected(role.name) && (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteRole(role.id, role.name);
                      }}
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        minWidth: 'auto',
                        padding: '4px',
                        color: 'error.main',
                        '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.1)' }
                      }}
                    >
                      <DeleteOutlineIcon sx={{ fontSize: 20 }} />
                    </Button>
                  )}
                  {ROLE_TABS[role.name]?.icon({ sx: { padding: '0.75rem', height: '48px', width: '48px', background: 'rgb(209, 209, 209, 0.2)', borderRadius: '5px', color: roleColors[index] } }) || <ManageAccountsIcon sx={{ padding: '0.75rem', height: '48px', width: '48px', background: 'rgb(209, 209, 209, 0.2)', borderRadius: '5px', color: roleColors[index] }} />}
                  <Box>
                    <Typography sx={{ fontSize: 16 }}>
                      {ROLE_TABS[role.name]?.label || asTitle(role.name.replace('ROLE_', ''))}
                    </Typography>
                    <Typography sx={{ fontSize: 12 }}>
                      {ROLE_TABS[role.name]?.description || `Manage ${ROLE_TABS[role.name]?.label || asTitle(role.name.replace('ROLE_', ''))} Permissions`}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, padding: '1rem 0' }}>
                    {role?.permissions?.filter(permission => permission.name.includes('.access')).map((permission, index) => (
                      <Chip key={index} label={asTitle(permission.name.replace('.', ' '))} icon={<KeyIcon />} />
                    ))}
                  </Box>
                </Box>

              </Grid2>
            ))}
            {!addRole && (
              <Button onClick={handleAddRole}>Add Role</Button>
            )}
            {addRole && (
              <Box sx={{ display: 'flex', gap: 1, padding: '1rem' }}>
                <TextField
                  label="Role Name"
                  variant="outlined"
                  name='newRoleName'
                  value={newRoleName}
                  required
                  onChange={(event) => setNewRoleName(event.target.value)}
                />
                <Button onClick={cancelAddRole}>Cancel</Button>
                <Button onClick={handleAddRoleSubmit}>Add</Button>
              </Box>
            )}
          </Grid2>
        </Container>
      )}
      {!selectedModel && selectedRole !== null && (
        <Container sx={{ mt: 4, mb: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button onClick={() => setSelectedRole(null)} startIcon={<ArrowBackIosNewIcon sx={{ height: '15px', color: 'black' }} />} sx={{ fontSize: '13px', color: 'black' }}>Back</Button>
              {ROLE_TABS[roles[selectedRole].name]?.icon() || <ManageAccountsIcon />}
              <Box>
                <Typography sx={{ textAlign: 'left', color: 'black' }}>
                  {ROLE_TABS[roles[selectedRole].name]?.label || asTitle(roles[selectedRole].name.replace('ROLE_', ''))}
                </Typography>
                <Typography sx={{ fontSize: 12, textAlign: 'left', color: 'gray' }}>
                  {ROLE_TABS[roles[selectedRole].name]?.description || `Manage ${ROLE_TABS[roles[selectedRole].name]?.label || asTitle(roles[selectedRole].name.replace('ROLE_', ''))} Permissions`}
                </Typography>
              </Box>
            </Box>
            <TextField
              label="Search"
              variant="outlined"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ '& .MuiInputBase-input': { height: '0.5rem' } }}
            />
          </Box>
          <Divider />
          <Grid2 container spacing={2} columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}>
            {filteredModels.map((model, index) => (
              <Grid2 size={1} key={index}>
                <Box className="rbac-card" data-model={model} onClick={handleSelectModel}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {MODEL_MUI_ICONS_AND_COLORS[model]?.icon({ sx: { padding: '0.75rem', height: '48px', width: '48px', background: 'rgb(209, 209, 209, 0.2)', borderRadius: '5px', color: colors[index] } }) || <KeyIcon sx={{ padding: '0.75rem', height: '48px', width: '48px', background: 'rgb(209, 209, 209, 0.2)', borderRadius: '5px', color: colors[index] }} />}
                    <Typography sx={{ fontSize: 12 }}>
                      {modelColumns[model]?.length || 0} fields
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 16 }}>
                      {asTitle(model)}
                    </Typography>
                    <Typography sx={{ fontSize: 12 }}>
                      {MODEL_MUI_ICONS_AND_COLORS[model]?.description || `Manage ${asTitle(model).toLowerCase()} Permissions`}
                    </Typography>
                  </Box>
                  {/* Box of chips with model permissions  */}
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, padding: '1rem 0' }}>
                    {selectedRolePermissions?.filter(permission => permission.startsWith(`${model}-`) && permission.split('-').length === 2 && !permission.split('-')[1].includes('.')).map((permission, index) => (
                      <Chip key={index} label={asTitle(permission.replace(`${model}-`, ''))} icon={MODEL_ACTIONS[permission.replace(`${model}-`, '')]?.icon || <KeyIcon />} />
                    ))}
                  </Box>
                </Box>
              </Grid2>
            ))}
          </Grid2>
        </Container>
      )}
      {selectedModel && (
        <Container sx={{ mt: 4, mb: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button onClick={handleBack} startIcon={<ArrowBackIosNewIcon sx={{ height: '15px', color: 'black' }} />} sx={{ fontSize: '13px', color: 'black' }}>Back</Button>
              {ROLE_TABS[roles[selectedRole].name]?.icon() || <ManageAccountsIcon />}
              <Box>
                <Typography sx={{ textAlign: 'left', color: 'black' }}>
                  {ROLE_TABS[roles[selectedRole].name]?.label || asTitle(roles[selectedRole].name.replace('ROLE_', ''))}
                </Typography>
                <Typography sx={{ fontSize: 12, textAlign: 'left', color: 'gray' }}>
                  {ROLE_TABS[roles[selectedRole].name]?.description || `Manage ${ROLE_TABS[roles[selectedRole].name]?.label || asTitle(roles[selectedRole].name.replace('ROLE_', ''))} Permissions`}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2 }}>

              {editMode ? (
                <>
                  <Button onClick={togglePermissionsEditState}>Cancel</Button>
                  <Button onClick={handleSavePermissions}>Save</Button>
                </>
              ) : (
                !addRole && (<><Button onClick={handleAddRole}>Add Role</Button>
                  <Button onClick={togglePermissionsEditState}>Edit Permissions</Button></>)
              )}
            </Box>
          </Box>

          <Divider />
          <Grid2 container spacing={2} columns={{ xs: 2, sm: 2, md: 12, lg: 12 }}>
            <Grid2 size={4}>
              <Box sx={{ border: '1px solid rgba(229,231,235, 1)', borderRadius: '0.5rem', minHeight: '300px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between', padding: '1rem' }}>
                  <Typography sx={{ fontSize: 16 }}>
                    Roles
                  </Typography>
                  <TextField
                    label="Search"
                    variant="outlined"
                    name='rolesSearch'
                    onChange={handleRolesSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiInputBase-input': { height: '0.5rem' } }}
                  />
                </Box>
                <Divider />
                <Tabs
                  orientation="vertical"
                  // variant="scrollable"
                  value={selectedRole}
                  onChange={handleRoleTabChange}
                  aria-label="Vertical tabs example"
                  sx={{
                    '& .MuiTabs-indicator': {
                      left: 0,
                      width: '4px',
                    }, '& .Mui-selected': {
                      background: 'rgba(59, 130, 246, 0.1)',
                    }, '& .MuiTab-root:hover': {
                      background: 'rgba(0, 0, 0, 0.1)',
                    },
                  }}
                >
                  {filteredRoles.map((role, index) => (
                    <Tab key={index} label={
                        <Box>
                          <Typography sx={{ textAlign: 'left', color: 'black' }}>
                            {ROLE_TABS[role.name]?.label || asTitle(role.name.replace('ROLE_', ''))}
                          </Typography>
                          <Typography sx={{ fontSize: 12, textAlign: 'left', color: 'gray' }}>
                            {ROLE_TABS[role.name]?.description || `Manage ${ROLE_TABS[role.name]?.label || asTitle(role.name.replace('ROLE_', ''))} Permissions`}
                          </Typography>
                      </Box>
                    } icon={ROLE_TABS[role.name]?.icon() || <ManageAccountsIcon />} iconPosition="start" sx={{ justifyContent: 'flex-start', gap: 2, minHeight: '0', maxWidth: '100%', textTransform: 'none' }} />
                  ))}
                </Tabs>
                <Divider />
                {addRole && (
                  <Box sx={{ display: 'flex', gap: 1, padding: '1rem' }}>
                    <TextField
                      label="Role Name"
                      variant="outlined"
                      name='newRoleName'
                      value={newRoleName}
                      required
                      onChange={(event) => setNewRoleName(event.target.value)}
                    />
                    <Button onClick={cancelAddRole}>Cancel</Button>
                    <Button onClick={handleAddRoleSubmit}>Add</Button>
                  </Box>
                )}
              </Box>
            </Grid2>
            <Grid2 size={8}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {MODEL_MUI_ICONS_AND_COLORS[selectedModel]?.icon({ sx: { padding: '0.75rem', height: '48px', width: '48px', background: 'rgb(209, 209, 209, 0.2)', borderRadius: '5px', color: colors[filteredModels.indexOf(selectedModel)] } }) || <KeyIcon sx={{ padding: '0.75rem', height: '48px', width: '48px', background: 'rgb(209, 209, 209, 0.2)', borderRadius: '5px', color: colors[filteredModels.indexOf(selectedModel)] }} />}
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography sx={{ fontSize: 20 }}>
                      {asTitle(selectedModel)}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }}>
                      {MODEL_MUI_ICONS_AND_COLORS[selectedModel]?.description || `Manage ${asTitle(selectedModel).toLowerCase()} Permissions`}
                    </Typography>
                  </Box>
                </Box>
                <Divider />
                <Tabs
                  value={selectedPermissionsTab}
                  onChange={(event, newValue) => setSelectedPermissionsTab(newValue)}
                  textColor="inherit"
                  sx={{ '& .MuiTabs-list': { gap: 2 } }}
                >
                  <Tab label="Model Permissions" icon={<TableChartIcon />} iconPosition="start" sx={{ justifyContent: 'flex-start', gap: 2, minHeight: '0', maxWidth: 'fit-content', textTransform: 'none' }} />
                  {modelColumns[selectedModel]?.length > 0 && (
                    <Tab label="Column Permissions" icon={<ViewWeekIcon />} iconPosition="start" sx={{ justifyContent: 'flex-start', gap: 2, minHeight: '0', maxWidth: 'fit-content', textTransform: 'none' }} />
                  )}
                </Tabs>
                <Divider />
                {selectedPermissionsTab === 0 && (
                  <FormGroup sx={{ border: '1px solid rgba(229,231,235, 1)', borderRadius: '0.5rem', minHeight: '350px' }}>
                    <Typography sx={{ fontSize: 16, padding: '1rem', display: 'flex', alignItems: 'center', gap: 2 }}>
                      <TableChartIcon />Model Permissions
                    </Typography>
                    <Divider />
                    {MODEL_ACTIONS && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '1rem' }}>
                        {Object.keys(MODEL_ACTIONS).map((permission, index) => (
                          <React.Fragment key={index}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              {MODEL_ACTIONS[permission]?.icon}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  <Typography sx={{ fontSize: 14 }}>
                                    {MODEL_ACTIONS[permission].label}
                                  </Typography>
                                  <Typography sx={{ fontSize: 12 }}>
                                    {MODEL_ACTIONS[permission].description}
                                  </Typography>
                                </Box>
                                <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`${selectedModel}-${permission}`)} data-permission={`${selectedModel}-${permission}`} onClick={handlePermissionChange} />
                              </Box>
                            </Box>
                            {isPermissionChecked(`${selectedModel}-${permission}`) && (MODEL_ACTIONS[permission]?.children || selectedModel === 'users') && (
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 0 0 1rem' }}>
                                <>
                                  {Object.keys(MODEL_ACTIONS[permission].children || {}).map((childPermission, index) => (
                                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography sx={{ fontSize: 14 }}>
                                          {MODEL_ACTIONS[permission].children[childPermission].label}
                                        </Typography>
                                        <Typography sx={{ fontSize: 12 }}>
                                          {MODEL_ACTIONS[permission].children[childPermission].description}
                                        </Typography>
                                      </Box>
                                      <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`${selectedModel}-${childPermission}`)} data-permission={`${selectedModel}-${childPermission}`} onClick={handlePermissionChange} />
                                    </Box>
                                  ))}
                                  <Divider />
                                  {selectedModel === 'users' && roles?.map((role, index) => (
                                    !['ROLE_GUEST', 'ROLE_PAYMENT_PROCESSOR'].includes(role.name) && (<React.Fragment key={index}>
                                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography sx={{ fontSize: 14 }}>
                                            {asTitle(permission.replace('', ''))} {asTitle(role.name.replace('ROLE_', ''))}
                                          </Typography>
                                          <Typography sx={{ fontSize: 12 }}>
                                            {`Can ${permission.replace('', '')} ${asTitle(role.name.replace('ROLE_', ''))}`}
                                          </Typography>
                                        </Box>
                                        <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`users-${permission}.${role.name}`)} data-permission={`users-${permission}.${role.name}`} onClick={handlePermissionChange} />
                                      </Box>
                                      {permission === 'manage' && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: 14 }}>
                                              Manage permissions of {asTitle(role.name.replace('ROLE_', ''))}
                                            </Typography>
                                            <Typography sx={{ fontSize: 12 }}>
                                              {`Can manage permissions of ${asTitle(role.name.replace('ROLE_', ''))}`}
                                            </Typography>
                                          </Box>
                                          <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`users-manage.permissions.${role.name}`)} data-permission={`users-manage.permissions.${role.name}`} onClick={handlePermissionChange} />
                                        </Box>
                                      )}</React.Fragment>)
                                  ))}
                                </>
                              </Box>
                            )}
                            <Divider />
                          </React.Fragment>
                        ))}
                      </Box>
                    )}
                    {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '1rem' }}>  */}
                    {/* </Box> */}
                  </FormGroup>
                )}
                {selectedPermissionsTab === 1 && (
                  <Box sx={{ border: '1px solid rgba(229,231,235, 1)', borderRadius: '0.5rem', minHeight: '350px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Typography sx={{ fontSize: 16, padding: '1rem', display: 'flex', alignItems: 'center', gap: 2 }}>
                        {selectedColumn && (<Button onClick={handleColumnBack} startIcon={<ArrowBackIosNewIcon sx={{ height: '15px', color: 'black' }} />} sx={{ fontSize: '13px', color: 'black' }}>Back</Button>)}
                        <ViewWeekIcon />
                        Column Permissions {selectedColumn ? ` | ${asTitle(selectedColumn)}` : ''}
                      </Typography>
                      {!selectedColumn && (
                        <TextField
                          label="Search"
                          variant="outlined"
                          onChange={handleColumnSearch}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            ),
                          }}
                          sx={{ margin: '1rem', '& .MuiInputBase-input': { height: '0.5rem' } }}
                        />)}
                    </Box>
                    <Divider />
                    {!selectedColumn && (
                      <Grid2 container spacing={2} columns={{ xs: 2, sm: 2, md: 3, lg: 4 }} sx={{ padding: '1rem' }}>
                        {filteredModelColumns && filteredModelColumns.map((column, index) => (
                          <Grid2 size={1} key={index}>
                            <Button sx={{ justifyContent: 'flex-start', width: '100%', color: 'black' }} onClick={handleColumnChange} data-column={column}>{asTitle(column)}</Button>
                          </Grid2>
                        ))}
                      </Grid2>
                    )}
                    {
                      selectedColumn && COLUMN_ACTIONS && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '1rem' }}>
                          {Object.keys(COLUMN_ACTIONS).map((permission, index) => (
                            <React.Fragment key={index}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                {COLUMN_ACTIONS[permission]?.icon}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography sx={{ fontSize: 14 }}>
                                      {COLUMN_ACTIONS[permission].label}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12 }}>
                                      {COLUMN_ACTIONS[permission].description}
                                    </Typography>
                                  </Box>
                                  <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`${selectedModel}-column[${selectedColumn}]-${permission}`)} onClick={handlePermissionChange} data-permission={`${selectedModel}-column[${selectedColumn}]-${permission}`} />
                                </Box>
                              </Box>
                              {isPermissionChecked(`${selectedModel}-column[${selectedColumn}]-${permission}`) && (COLUMN_ACTIONS[permission]?.children || selectedModel === 'users') && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '0 0 0 1rem' }}>
                                  <>
                                    {Object.keys(COLUMN_ACTIONS[permission].children).map((childPermission, index) => (
                                      <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography sx={{ fontSize: 14 }}>
                                            {COLUMN_ACTIONS[permission].children[childPermission].label}
                                          </Typography>
                                          <Typography sx={{ fontSize: 12 }}>
                                            {COLUMN_ACTIONS[permission].children[childPermission].description}
                                          </Typography>
                                        </Box>
                                        <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`${selectedModel}-column[${selectedColumn}]-${childPermission}`)} onClick={handlePermissionChange} data-permission={`${selectedModel}-column[${selectedColumn}]-${childPermission}`} />
                                      </Box>
                                    ))}
                                    <Divider />
                                    {selectedModel === 'users' && roles?.map((role, index) => (
                                      !['ROLE_GUEST', 'ROLE_PAYMENT_PROCESSOR'].includes(role.name) && (<React.Fragment key={index}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ fontSize: 14 }}>
                                              {asTitle(permission.replace('', ''))} {asTitle(role.name.replace('ROLE_', ''))}
                                            </Typography>
                                            <Typography sx={{ fontSize: 12 }}>
                                              {`Can ${permission.replace('', '')} ${asTitle(role.name.replace('ROLE_', ''))}`}
                                            </Typography>
                                          </Box>
                                          <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`users-column[${selectedColumn}]-${permission}.${role.name}`)} data-permission={`users-column[${selectedColumn}]-${permission}.${role.name}`} onClick={handlePermissionChange} />
                                        </Box>
                                        {permission === 'manage' && (
                                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                              <Typography sx={{ fontSize: 14 }}>
                                                Manage permissions of {asTitle(role.name.replace('ROLE_', ''))}
                                              </Typography>
                                              <Typography sx={{ fontSize: 12 }}>
                                                {`Can manage permissions of ${asTitle(role.name.replace('ROLE_', ''))}`}
                                              </Typography>
                                            </Box>
                                            <MaterialUISwitch disabled={!editMode} sx={{ m: 1, opacity: editMode ? 1 : 0.5 }} checked={isPermissionChecked(`users-column[${selectedColumn}]-manage.permissions.${role.name}`)} data-permission={`users--column[${selectedColumn}]manage.permissions.${role.name}`} onClick={handlePermissionChange} />
                                          </Box>
                                        )}</React.Fragment>)
                                    ))}
                                  </>
                                </Box>
                              )}
                              <Divider />
                            </React.Fragment>
                          ))}
                        </Box>
                      )}
                  </Box>
                )}
              </Box>
            </Grid2>
          </Grid2>

        </Container >
      )}
    </>
  );
};
